import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 查询目标变更信息-yjl
export const getGoalChangeInfo = (data) => {
    return request({
        url: apiCrmHost + '/neoCrm/GoalChange/query',
        method: 'post',
        data
    });
};
// 查询目标变更信息-保存 -yjl
export const saveGoalManageForm = (data) => {
    return request({
        url: apiCrmHost + '/neo/goalChange/save',
        method: 'post',
        data
    });
};
